var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDeslikedisable = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#BFC3CA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1467_2493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1467_2493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 16H35.1666V33.3333L25.8333 42.6667L24.1666 41C24.011 40.8444 23.8833 40.6333 23.7833 40.3667C23.6833 40.1 23.6333 39.8444 23.6333 39.6V39.1333L25.0999 33.3333H16.4999C15.7888 33.3333 15.1666 33.0667 14.6333 32.5333C14.0999 32 13.8333 31.3778 13.8333 30.6667V28C13.8333 27.8444 13.8555 27.6778 13.8999 27.5C13.9444 27.3222 13.9888 27.1556 14.0333 27L18.0333 17.6C18.2333 17.1556 18.5666 16.7778 19.0333 16.4667C19.4999 16.1556 19.9888 16 20.4999 16ZM32.4999 18.6667H20.4999L16.4999 28V30.6667H28.4999L26.6999 38L32.4999 32.2V18.6667ZM35.1666 33.3333V30.6667H39.1666V18.6667H35.1666V16H41.8333V33.3333H35.1666Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeslikedisable, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deslikedisable.88772135.svg";
export { ForwardRef as ReactComponent };